import { render, staticRenderFns } from "./VisitorLogPage.vue?vue&type=template&id=5c506830&scoped=true&"
import script from "./VisitorLogPage.vue?vue&type=script&lang=js&"
export * from "./VisitorLogPage.vue?vue&type=script&lang=js&"
import style0 from "./VisitorLogPage.vue?vue&type=style&index=0&id=5c506830&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c506830",
  null
  
)

export default component.exports